(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .slide_brand");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
            _slick.slick (
            {
            slidesToScroll: 1,
            infinite: false,
            nextArrow: '<button type="button" class="brand-slick-prev brand-slick"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
            prevArrow: '<button type="button" class="brand-slick-prev brand-slick"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
			slidesToShow: 5,
			responsive: [
			{
                  breakpoint: 1034,
                   settings: {
                   slidesToShow: 4,
                   slidesToScroll: 1
                   }
                   },
                   {
                   breakpoint: 800,
                   settings: {
                   slidesToShow: 3,
                   slidesToScroll: 1
                   }
                   },
                   {
                   breakpoint: 500,
                   settings: {
                   slidesToShow: 1,
                   slidesToScroll: 1
                   }
                   }
				]
            }
            );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load',  process_slick_event)
 .on( 'shopify:section:unload', process_slick_event )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-icon-text"] && !Shopify.designMode) return;
  try {
    

function process_slick_event(evt) {
	var _slick = $("#" + evt.target.id + " .featured_icon_text");
	if (_slick.length) {
		switch (evt.originalEvent.type) {
			case "shopify:section:load":
				console.log('Load ' + _slick.attr("id"));
				_slick.slick({
					slidesToScroll: 1,
					infinite: false,
          arrows: false,
					slidesToShow: 4,
					responsive: [
						{
							breakpoint: 1000,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 500,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
                dots: true,
							}
						}
					]
				});
				break;
			case "shopify:section:unload":
				console.log('Unload ' + _slick.attr("id"));
				_slick.slick('unslick');
				break;

		}
	}
}

$(document)
	.on('shopify:section:load', process_slick_event)
	.on('shopify:section:unload', process_slick_event);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-logo"] && !Shopify.designMode) return;
  try {
    

function process_slick_event(evt) {
	var _slick = $("#" + evt.target.id + " .featured_logo");
	if (_slick.length) {
		switch (evt.originalEvent.type) {
			case "shopify:section:load":
				console.log('Load ' + _slick.attr("id"));
				_slick.slick({
					slidesToScroll: 3,
					infinite: true,
          arrows: false,
					slidesToShow: 6,
          dots: true,
					responsive: [
						{
							breakpoint: 1000,
							settings: {
								slidesToShow: 5,
								slidesToScroll: 2
							}
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 4,
								slidesToScroll: 2
							}
						},
						{
							breakpoint: 500,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 2,
                dots: true,
							}
						}
					]
				});
				break;
			case "shopify:section:unload":
				console.log('Unload ' + _slick.attr("id"));
				_slick.slick('unslick');
				break;

		}
	}
}

$(document)
	.on('shopify:section:load', process_slick_event)
	.on('shopify:section:unload', process_slick_event);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    

function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .featured_product");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
            _slick.slick (
            {
            slidesToScroll: 1,
            infinite: false,
            nextArrow: '<button type="button" class="featured-product-slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
            prevArrow: '<button type="button" class="featured-product-slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
			slidesToShow: 4,
            responsive: [
            {
            breakpoint: 1034,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 1
            }
            },
            {
            breakpoint: 800,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 1
            }
            },
            {
            breakpoint: 767,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1
            }
            },
            {
            breakpoint: 330,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
            }
            ]
            }
            );
            break; 
            case "shopify:section:unload" :
            console.log('Unload ' + _slick.attr("id"));
            _slick.slick('unslick');
            break;

            } 
  }
}
    
$(document)
 .on( 'shopify:section:load',  process_slick_event)
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .header_center_free_shipping");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" :
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
                slidesToScroll: 1,
        		arrows: true,
        		autoplay: true,
      			fade: true
            }
          );
      break;
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     }
  }
}

$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"]) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .lookbook_page .single-item");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
              dots: true,
     		 slidesToScroll: 1,
      		 
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function process_slick_event(evt) {
    var carousel = $('[data-owl]');
    if (carousel.length) {
      carousel.each(function(index, el) {
        $(this).owlCarousel($(this).data('owl'));
      });
    }
  }
  $(document)
    .on('shopify:section:load', process_slick_event)
    .on('shopify:section:unload', process_slick_event);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .home-slideshow .variable-width");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" :
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
              dots: true,
     		 slidesToScroll: 1,

              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break;
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     }
  }
}

$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();
})();
